import React from 'react';

const RaportyKsiegowe = () => {
  return (
    <div>
      <h1>Raporty księgowe</h1>
    </div>
  );
};

export default RaportyKsiegowe;
